import { createFileRoute } from '@tanstack/react-router'

import { CommFilesPage } from '#/modules/communication/files-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/comm-files')({
  component: CommFilesPage,
  validateSearch: validateListSearch,
})
